import { render, staticRenderFns } from "./type81.vue?vue&type=template&id=3b3e3188&scoped=true"
import script from "./type81.vue?vue&type=script&lang=js"
export * from "./type81.vue?vue&type=script&lang=js"
import style0 from "./type81.vue?vue&type=style&index=0&id=3b3e3188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3e3188",
  null
  
)

export default component.exports